import { isEqual } from 'lodash'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import { getStateDataById } from '../selectLists/states/mockData'
import type { TEntityId } from '~/types/models'
import type { ITsdResource } from '~/types/tsd/models'
import { getResourceUseById } from '~/services/selectLists'
import { ResourceUseIds } from '~/services/selectLists/resourceUses'
import { getCountryDataById } from '~/api/msw/api/selectLists/countries/mockData'
import { CountryIds } from '~/services/selectLists/countries'

const tsdResourceListData = undefined as unknown as ITsdResource[]

export const getTsdResourceListData = getListDataFunctionFactory<
  ITsdResource[]
>({
  listData: tsdResourceListData,
  storageKey: 'tsdresources',
  getStartingListData: getStartingTsdResourceListData,
})

export async function getTsdResourceDataById(
  id: TEntityId
): Promise<ITsdResource> {
  const list: ITsdResource[] = await getTsdResourceListData()
  if (!list) {
    throw new Error(`getTsdResourceList returned undefined/null`)
  }
  const tsdResource = list.find((tsdr) => tsdr.id === id)
  if (!tsdResource) {
    throw new Error(`Can't find resource '${id}'`)
  }
  return tsdResource
}

export async function getTsdResourceListDataByTsdId(id: string) {
  const list = await getTsdResourceListData()
  if (!list) {
    throw new Error(`getTsdResourceList returned undefined/null`)
  }
  return list.filter((tsdResource: ITsdResource) =>
    isEqual(tsdResource.tsd?.id, id)
  ) as ITsdResource[]
}

export async function getTsdResourceListDataWithUseForRegistrationByTsdId(
  id: string
) {
  const list = await getTsdResourceListData()
  if (!list) {
    throw new Error(`getTsdResourceList returned undefined/null`)
  }
  return list.filter(
    (tsdResource: ITsdResource) =>
      isEqual(tsdResource.tsd?.id, id) &&
      tsdResource.useFor?.find((uf) => uf.id === ResourceUseIds.REGISTRATIONS)
  ) as ITsdResource[]
}

export async function getStartingTsdResourceListData(): Promise<
  ITsdResource[]
> {
  const unitedStates = await getCountryDataById(CountryIds.UNITED_STATES)
  const massachusetts = await getStateDataById(1433)
  return [
    {
      id: 'XXTRE0001',
      hrid: 'TRE0001',
      tsd: {
        id: 'XXT0001',
        label: 'TBI',
      },
      descr: 'Registration Desk',
      email: 'registrations@tbi.com',
      address: {
        country: unitedStates,
        addressLine1: '456 Blue Street',
        addressLine2: 'Suite 400',
        city: 'Boston',
        state: massachusetts,
        zip: '04359',
      },
      useFor: [getResourceUseById(ResourceUseIds.REGISTRATIONS)],
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
    {
      id: 'XXTRE0002',
      hrid: 'TRE0002',
      tsd: {
        id: 'XXT0001',
        label: 'TBI',
      },
      descr: 'RFQ Email',
      email: 'rfp@tbi.com',
      address: {
        country: unitedStates,
        addressLine1: '456 Blue Street',
        addressLine2: 'Suite 400',
        city: 'Boston',
        state: massachusetts,
        zip: '04359',
      },
      useFor: [getResourceUseById(ResourceUseIds.RFQS)],
      status: {
        id: 2,
        label: 'Active',
      },
      version: '1',
      canBeDeleted: true,
    },
  ]
}
